import React, { useEffect, useRef } from 'react';

export default function FormText({
  defaultValue,
  handleSelectedChange,
  handleArgs
}) {
  const textareaRef = useRef(null);
  useEffect(() => {
    textareaRef.current.style.height = '0px';
    const scrollHeight = textareaRef.current.scrollHeight;
    textareaRef.current.style.height = scrollHeight + 'px';
  }, [defaultValue]);

  return (
    <>
      <form>
        <textarea
          ref={textareaRef}
          className='textarea'
          value={String(defaultValue)}
          placeholder='Enter Text'
          onChange={(e) => {
            handleSelectedChange(...handleArgs, e.target.value);
          }}
        />
      </form>
    </>
  );
}
